export class ArrayEditActionEntity {
  add?: Array<string>;
  erase?: Array<string>;
}

export class CapabilityActionRequestEntity {
  name?: string;
  code?: string;
  key?: string;
  displayName?: string;
  type?: number;
  status?: number;
  note?: string;
  description?: string;
  configuration?: Record<string, unknown>;
  feature?: string;
  menus?: ArrayEditActionEntity | Array<string>;
  order?: string;

  constructor(data?: Partial<CapabilityActionRequestEntity>) {
    if (!data) return;

    this.name = data.name;
    this.code = data.code;
    this.key = data.key;
    this.displayName = data.displayName;
    this.type = data.type;
    this.status = data.status;
    this.note = data.note;
    this.description = data.description;
    this.configuration = data.configuration;
    this.feature = data.feature;
    this.menus = data.menus;
    this.order = data.order;
  }
}
